<div class="flex flex-col w-full" data-testid="global-templates">
  <app-breadcrumb [items]="breadcrumbs" />

  <div class="mt-4">
    <app-template-settings class="w-full" />
  </div>
</div>
